import styles from './HelpText.module.css';
import clsx from 'clsx';

export const HelpText = (props: React.HTMLAttributes<HTMLDivElement>) => <div className={clsx(styles.helpText, props.className)} {...props} />;
